import { Component, ViewEncapsulation } from '@angular/core';
import { UIBlockingService } from '../../../core/ui-blocking.service';
import { ToastNotificationService } from '../../../core/toast-notification.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DumbCompanyDetails } from '../DTOs/dumb-company';
import { CommonLibrary } from '../../../core/common-library';
import { MembershipManagementService } from '../membership-management.service';
import { UpdatePaymentInfoRequest } from '../DTOs/update-payment-info-request';

@Component({
  selector: 'app-edit-company-payment-info-modal',
  templateUrl: './edit-company-payment-info-modal.component.html',
  encapsulation: ViewEncapsulation.None
})
export class EditCompanyPaymentInfoModalComponent {

    constructor(private membershipService: MembershipManagementService
        , private blockUI: UIBlockingService
        , private notificationService: ToastNotificationService
        , private modalService: NgbModal
        , private activeModal: NgbActiveModal) {
    }


    paymentTypeCtrl = new FormControl("paymentType");

    cardNumberCtrl = new FormControl("cardNumber", [Validators.required]);
    cardExpirationCtrl = new FormControl("cardExpiration", [Validators.required]);
    CVVCtrl = new FormControl("cvv", [Validators.required]);
    billingAddressCtrl = new FormControl("billingAddress", [Validators.required]);
    cityCtrl = new FormControl("city", [Validators.required]);
    stateCtrl = new FormControl("State", [Validators.required]);
    zipCtrl = new FormControl("zip", [Validators.required]);

    routingNumberCtrl = new FormControl("routingNumber");
    accountNumber1Ctrl = new FormControl("accountNumber1");
    accountNumber2Ctrl = new FormControl("accountNumber2");
    nameOnAccountCtrl = new FormControl("nameOnAccount");

    manageMembershipInfoForm: FormGroup = new FormGroup({
        paymentType: this.paymentTypeCtrl,
        cardNumber: this.cardNumberCtrl,
        cardExpiration: this.cardExpirationCtrl,
        cvv: this.CVVCtrl,
        billingAddress: this.billingAddressCtrl,
        city: this.cityCtrl,
        state: this.stateCtrl,
        zip: this.zipCtrl,

        routingNumber: this.routingNumberCtrl,
        accountNumber1: this.accountNumber1Ctrl,
        accountNumber2: this.accountNumber2Ctrl,
        nameOnAccount: this.nameOnAccountCtrl,
    });
    company: DumbCompanyDetails;
    validationTriggered = false;
    isBusy = false;

    paymentType() { return this.manageMembershipInfoForm.get('paymentType').value }

    cardNumber() { return this.manageMembershipInfoForm.get('cardNumber').value }
    cardExpiration() { return this.manageMembershipInfoForm.get('cardExpiration').value }
    cvv() { return this.manageMembershipInfoForm.get('cvv').value }
    billingAddress() { return this.manageMembershipInfoForm.get('billingAddress').value }
    city() { return this.manageMembershipInfoForm.get('city').value }
    state() { return this.manageMembershipInfoForm.get('state').value }
    zip() { return this.manageMembershipInfoForm.get('zip').value }

    routingNumber() { return this.manageMembershipInfoForm.get('routingNumber').value }
    accountNumber1() { return this.manageMembershipInfoForm.get('accountNumber1').value }
    accountNumber2() { return this.manageMembershipInfoForm.get('accountNumber2').value }
    nameOnAccount() { return this.manageMembershipInfoForm.get('nameOnAccount').value }
    accountNumbersMatchError: boolean = false;

    ngOnInit() {
        this.resetManageMembershipForm();
    }
    private resetManageMembershipForm(): void {
        this.manageMembershipInfoForm.reset();
        this.manageMembershipInfoForm.get('paymentType').valueChanges.subscribe(val => {
            this.clearPaymentValidators();
            this.setPaymentValidators(val);
        });
        this.manageMembershipInfoForm.patchValue({
            paymentType: this.company.paymentType,
        });
    }

    dismiss(): void {
        this.activeModal.dismiss();
    }

    setPaymentValidators(val) {
        if (val == 1) {
            this.manageMembershipInfoForm.get('cardNumber').setValidators(Validators.required);
            this.manageMembershipInfoForm.get('cardExpiration').setValidators(Validators.required);
            this.manageMembershipInfoForm.get('cvv').setValidators(Validators.required);
            this.manageMembershipInfoForm.get('billingAddress').setValidators(Validators.required);
            this.manageMembershipInfoForm.get('city').setValidators(Validators.required);
            this.manageMembershipInfoForm.get('state').setValidators(Validators.required);
            this.manageMembershipInfoForm.get('zip').setValidators(Validators.required);
        }
        else if (val == 2) {
            this.manageMembershipInfoForm.get('routingNumber').setValidators(Validators.required);
            this.manageMembershipInfoForm.get('accountNumber1').setValidators(Validators.required);
            this.manageMembershipInfoForm.get('accountNumber2').setValidators(Validators.required);
            this.manageMembershipInfoForm.get('nameOnAccount').setValidators(Validators.required);
        }
        this.manageMembershipInfoForm.get('routingNumber').updateValueAndValidity();
        this.manageMembershipInfoForm.get('accountNumber1').updateValueAndValidity();
        this.manageMembershipInfoForm.get('accountNumber2').updateValueAndValidity();
        this.manageMembershipInfoForm.get('cardNumber').updateValueAndValidity();
        this.manageMembershipInfoForm.get('cardExpiration').updateValueAndValidity();
        this.manageMembershipInfoForm.get('cvv').updateValueAndValidity();
        this.manageMembershipInfoForm.get('billingAddress').updateValueAndValidity();
        this.manageMembershipInfoForm.get('city').updateValueAndValidity();
        this.manageMembershipInfoForm.get('state').updateValueAndValidity();
        this.manageMembershipInfoForm.get('zip').updateValueAndValidity();
        this.manageMembershipInfoForm.get('nameOnAccount').updateValueAndValidity();
    }

    clearPaymentValidators() {
        this.manageMembershipInfoForm.get('cardNumber').clearValidators();
        this.manageMembershipInfoForm.get('cardExpiration').clearValidators();
        this.manageMembershipInfoForm.get('cvv').clearValidators();
        this.manageMembershipInfoForm.get('routingNumber').clearValidators();
        this.manageMembershipInfoForm.get('accountNumber1').clearValidators();
        this.manageMembershipInfoForm.get('accountNumber2').clearValidators();
        this.manageMembershipInfoForm.get('billingAddress').clearValidators();
        this.manageMembershipInfoForm.get('city').clearValidators();
        this.manageMembershipInfoForm.get('state').clearValidators();
        this.manageMembershipInfoForm.get('zip').clearValidators();
        this.manageMembershipInfoForm.get('nameOnAccount').clearValidators();

        this.manageMembershipInfoForm.get('routingNumber').updateValueAndValidity();
        this.manageMembershipInfoForm.get('accountNumber1').updateValueAndValidity();
        this.manageMembershipInfoForm.get('accountNumber2').updateValueAndValidity();
        this.manageMembershipInfoForm.get('cardNumber').updateValueAndValidity();
        this.manageMembershipInfoForm.get('cardExpiration').updateValueAndValidity();
        this.manageMembershipInfoForm.get('cvv').updateValueAndValidity();
        this.manageMembershipInfoForm.get('billingAddress').updateValueAndValidity();
        this.manageMembershipInfoForm.get('city').updateValueAndValidity();
        this.manageMembershipInfoForm.get('state').updateValueAndValidity();
        this.manageMembershipInfoForm.get('zip').updateValueAndValidity();
        this.manageMembershipInfoForm.get('nameOnAccount').updateValueAndValidity();
    }

    saveMembershipInfo() {
        for (var i in this.manageMembershipInfoForm.controls) {
            this.manageMembershipInfoForm.controls[i].markAsTouched();
        }
        if (!this.manageMembershipInfoForm.valid) {
            return;
        }

        if (this.paymentType() == 2) {
            if (this.accountNumber1() != this.accountNumber2()) {
                this.accountNumbersMatchError = true;
                return;
            }
        }

        this.blockUI.start();
        var request = new UpdatePaymentInfoRequest();
        request.paymentType = this.paymentType();

        request.cardNumber = this.cardNumber();
        request.cardExpiration = this.cardExpiration();
        request.cvv = this.cvv();
        request.billingAddress = this.billingAddress();
        request.city = this.city();
        request.state = this.state();
        request.zip = this.zip();

        request.routingNumber = this.routingNumber();
        request.accountNumber1 = this.accountNumber1();
        request.accountNumber2 = this.accountNumber2();
        request.nameOnAccount = this.nameOnAccount();
       
        this.membershipService.UpdateCompanyPaymentInfo(request)
            .subscribe({
                next: (data) => {
                },
                error: (err) => {
                    console.log(err);
                    this.notificationService.error(err.error.message);
                    this.blockUI.stop();
                },
                complete: () => {
                    this.blockUI.stop();
                    this.activeModal.close();
                }
            })
    }

}
